export interface INDRAPaymentCreditCard {
	status: string;
	errors: [];
	timeService: string;
	timeBackend: string;
	data: {
		idOperation: string;
		paymentResultAdyen: {
			errors: [];
			pspReference: string;
			resultCode: string;
			additionalData: {};
			issuerUrl: string,
			md: string;
			paRequest: string;
		};
		urlResponse: string;
		statusBook: string;
	};
}

export class BrowserInfo {
	acceptHeader: string;
	colorDepth: string;
	javaEnabled: string;
	language: string;
	screenHeight: string;
	screenWidth: string;
	timeZoneOffset: string;
	userAgent: string;

	constructor() {
		const useragent = window.navigator.userAgent;
		const language = window.navigator.language;
		const colorDepth = window.screen.colorDepth.toString();
		const javaEnabled = navigator.javaEnabled().toString();
		const screenHeight = screen.height.toString();
		const screenWidth = screen.width.toString();
		const timeZoneOffset = new Date().getTimezoneOffset().toString();

		const myHeaders = new Headers();
		// const deviceChannel =  navigator.userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile/i);
		myHeaders.append('Accept', 'application/json, text/plain, */*');
		this.acceptHeader = 'text/html,application/xml'; //text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8'
		this.colorDepth = colorDepth;
		this.javaEnabled = javaEnabled;
		this.language = language;
		this.screenHeight = screenHeight;
		this.screenWidth = screenWidth;
		this.timeZoneOffset = timeZoneOffset;
		this.userAgent = useragent;
	}
}


export class INDRAStatusTransaction {
	status: number;
	errors: [];
	timeService: string;
	timeBackend: string;
	data: {
		idOperation: string;
		paymentResultAdyen: {
			errors: [],
			pspReference: string;
			resultCode: string;
			additionalData: {}
		},
		statusBook: string
	};
}


export class INDRAAuthorised {
	data: {
		idOperation: string;
		paymentResultAdyen: {
			additionalData: {};
			authCode: string;
			errors: [];
			issuerUrl: string;
			mt: string;
			paRequest: string;
			paymentData: string;
			pspReference: string;
			refusalReason: string;
			resultCode: string;
			status: string;
			timeBackend: number;
			timeService: number
		},
		statusBook: string;
		urlResponse: string
	};
	errors: [];
	status: string;
	timeBackend: number;
	timeService: number;
}

export interface INDRASavedCardDeleteRequest {
	recurringDetailReference: string;
	merchantAccount: string;
	flyTapId: string;
}


export interface INDRASavedCardDeleteResponse {
	status: string;
	errors: [];
	timeService: string;
	timeBackend: string;
}















